import { render, staticRenderFns } from "./apple-login.vue?vue&type=template&id=5a82d562&scoped=true&"
import script from "./apple-login.vue?vue&type=script&lang=js&"
export * from "./apple-login.vue?vue&type=script&lang=js&"
import style0 from "./apple-login.vue?vue&type=style&index=0&id=5a82d562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82d562",
  null
  
)

export default component.exports